








































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Api
import { mapData, USER_API_MAPPING } from '@/api/Mapping'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'

// Components
import InfoBox from '@/components/common/InfoBox.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
import AddTeamMemberForm from '@/views/company/forms/AddTeamMemberForm.vue'

// Models
import User from '@/models/User'

@Component({
  components: {
    InfoBox,
    ModalWrapper,
    ImageViewer,
    AddTeamMemberForm
  }
})
export default class TeamCompany extends Mixins(Errors) {
  datas = []
  tableLoading = false
  firstLoad = true
  totalCount = null
  end = false
  limit = 20
  offset = 0

  addTeamModaleActive = false

  @Getter('token') token
  @Getter('master', { namespace: 'user' }) isMaster

  @Meta
  metas() {
    return {
      title: this.$t('company.menu.team'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  get params(): {} {
    return {
      limit: this.limit,
      offset: this.offset
    }
  }

  get isTeamEmpty(): boolean {
    return this.totalCount === 0
  }

  updateCount(array) {
    if (this.firstLoad) {
      this.totalCount = array.length
      this.firstLoad = false
    }
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = await this.$api.team.fetchTeam(this.token, this.params)
      const items = res.data.map((member) => new User(mapData(USER_API_MAPPING, member, false, true)))
      this.datas = add ? [...this.datas, ...items] : items
      this.updateCount(res.data)
      this.end = items.length === 0
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  @Watch('$route', { immediate: true })
  async updateTeam(route) {
    await this.fetch(false)
  }

  openTeamModale() {
    this.addTeamModaleActive = true
  }

  closeTeamModale() {
    this.addTeamModaleActive = false
  }

   async loadMore() {
    await this.fetch(true)
  }

  async deleteMember(row) {

    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('team.actions.delete.message') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          await this.$api.team.deleteMember(this.token, row.id)
          await this.reloadTeam()
          this.$toast.open({
            type: 'is-success',
            message: this.$t('team.actions.delete.success') as string
          })
        } catch (error) {
          this.displayErrors(error)
        }
      }
    })
  }

  async reloadTeam() {
    this.offset = 0
    await this.fetch(false)
  }
}
